import { render, staticRenderFns } from "./VPdfPreview.vue?vue&type=template&id=dab1ee90"
import script from "./VPdfPreview.vue?vue&type=script&lang=js"
export * from "./VPdfPreview.vue?vue&type=script&lang=js"
import style0 from "./VPdfPreview.vue?vue&type=style&index=0&id=dab1ee90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports